import React from 'react'
import { Outlet } from 'react-router-dom'
import Nav from '../components/nav'
import Footer from '../components/footer'

const ProtectedRoute = () => {
    return (
        <>
            <Nav />
            <Outlet />
        </>
    )
}

export default ProtectedRoute;